import React, {  useEffect, useState,useRef,useContext  } from "react";


export default function Maxpay_3ds(props) {
    

    console.log("maxpay module",props)

    useEffect(() => { 
        if(props){
            window.location.replace(props.action.acs_url)
        }
       
    },[props])


    return (
        <div className="all-container bg-light pianiAbbonamentoPage">
            
        </div>
    )
   


}